import actions from './actions'

export default function DocumentsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_DOCUMENT:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_DOCUMENT:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_DOCUMENT:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_DOCUMENT:
      return {
        ...state,
        editing: { documentID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_DOCUMENT_RECIEVED ||
      actions.UPDATE_DOCUMENT_RECIEVED ||
      actions.DELETE_DOCUMENT_RECIEVED:
      return {
        ...state,
        editing: { documentID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
